import { CeruleanButton } from 'components/Button'
import Column from 'components/Column'
import Field from 'components/Field'
import Input from 'components/Input'
import InputContainer from 'components/InputContainer'
import { selectors } from 'data'
import messages from 'lang'
import React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import { connect, ConnectedProps } from 'react-redux'

import Container from '../Modal/Container'

type PropsType = WrappedComponentProps & ConnectedProps<typeof connector>

const Verifypassword = ({ email, intl }: PropsType) => (
  <Container
    sub={intl.formatMessage(messages.sub_title_password_wall_2fa, { email })}
    title={intl.formatMessage(messages.title_password_wall_2fa)}
  >
    <Column>
      <InputContainer>
        <Field
          autoComplete='current-password'
          component={Input}
          e2e='currentPasswordInput'
          label={intl.formatMessage(messages.label_password)}
          name='password'
          type='password'
        />
      </InputContainer>

      <CeruleanButton e2e='verifyButton' type='submit'>
        {intl.formatMessage(messages.button_next)}
      </CeruleanButton>
    </Column>
  </Container>
)

const mapStateToProps = (state) => ({
  email: selectors.auth.getEmail(state)
})

const connector = connect(mapStateToProps)

export default connector(injectIntl(Verifypassword))
